function dengue(){
	return {
		"games":[
			{
				"informs":[
					{
						"text":"Os principais sintomas da dengue são: febre alta, maior que 38,5ºC; Dores musculares intensas; dor ao movimentar os olhos; mal estar; falta de apetite; dor de cabeça; após alguns dias pode aparecer amanchas vermelhas no corpo.",
						"title":"Sintomas",
						"image":"images/games/informs/dengue/sintomas/1.jpg",
					},
					{
						"text":"Mas, a infecção pelo vírus da dengue pode não apresentar sintomas, apresentar sintomas leves ou graves, podendo levar até a morte.",
						"title":"Sintomas",
						"image":"images/games/informs/dengue/sintomas/2.jpg",
					},
					{
						"text":"Normalmente, a primeira manifestação da dengue é a febre alta (39° a 40°C), de início abrupto, que geralmente dura de 2 a 7 dias, acompanhada de dor de cabeça, dores no corpo e nas articulações.",
						"title":"Sintomas",
						"image":"images/games/informs/dengue/sintomas/3.jpg",
					},
					{
						"text":"Na fase febril inicial da dengue, pode ser difícil diferenciá-la. A forma grave da doença inclui dor abdominal intensa e contínua, vômitos persistentes e sangramento de mucosas.",
						"title":"Sintomas",
						"image":"images/games/informs/dengue/sintomas/4.jpg",
					}
				],
				"pathImageGame":"midias/images/games/puzzles/dengue/sintomas/2.jpg"
			},
			{
				"informs":[
					{
						"text":"Não existe tratamento específico para a dengue. Em caso de suspeita é fundamental procurar um profissional de saúde para o correto diagnóstico.",
						"title":"Tratamento",
						"image":"images/games/informs/dengue/tratamento/1.jpg",
					},
					{
						"text":"O tratamento é feito de forma sintomática, sempre de acordo com avaliação do profissional de saúde, conforme cada caso.",
						"title":"Tratamento",
						"image":"images/games/informs/dengue/tratamento/2.jpg",
					},
					{
						"text":"A assistência em saúde é feita para aliviar os sintomas. Estão entre as formas de tratamento: fazer repouso e ingerir bastante líquido (água).",
						"title":"Tratamento",
						"image":"images/games/informs/dengue/tratamento/3.jpg",
					},
					{
						"text":"A hidratação pode ser por via oral (ingestão de líquidos pela boca) ou por via intravenosa (com uso de soro, por exemplo).",
						"title":"Tratamento",
						"image":"images/games/informs/dengue/tratamento/4.jpg",
					}
				],
				"pathImageGame":"midias/images/games/puzzles/dengue/tratamento/4.jpg"
			},
			{
				"informs":[
					{
						"text":"No momento, só existe uma vacina contra dengue registrada na Anvisa, que está disponível apenas na rede privada.",
						"title":"Curiosidades",
						"image":"images/games/informs/dengue/curiosidades/1.jpg",
					},
					{
						"text":"A vacina é usada em 3 doses no intervalo de 1 ano e só deve ser aplicada, segundo o fabricante, a OMS e a ANVISA, em pessoas que já tiveram pelo menos uma infecção por dengue.",
						"title":"Curiosidades",
						"image":"images/games/informs/dengue/curiosidades/2.jpg",
					}
				],
				"pathImageGame":"midias/images/games/puzzles/dengue/curiosidades/2.jpg"
			}
		]
	};
}

export {dengue};
